import Backbone from 'backbone'
import DatasetReportPath from '../dataset-report/dataset-report-path'
import InitiativeReportPath from '../initiative-report/initiative-report-path'
import ScorecardReportPath from '../scorecard-report/scorecard-report-path'
import SqlConsolePath from '../sql-console/sql-console-path'
import _ from 'lodash'
import permissions from 'scoreboard/components/permissions'
import i18n from 'scoreboard/components/i18n'
import globals from 'scoreboard/components/globals'
import BoxOptions from 'scoreboard/components/box-options'
import license from 'scoreboard/components/license'
import reportTypes from 'scoreboard/reports/report-types'
import InitiativeReportModel from 'scoreboard/reports/initiative-report/initiative-report-model'

var reportPathsByType = {
	'datasets' : DatasetReportPath,
	'initiatives': InitiativeReportPath,
	'scorecards': ScorecardReportPath,
	'sql' : SqlConsolePath
}

var Form = Backbone.View.extend({

	// this.model is a ReportWizardInfo object

	className: 'report-types',

	events: {
		'click td.report-type' : 'select'
	},

	initialize: function() {
		let availableOptions = reportTypes()

		this.boxOptions = new BoxOptions({ availableOptions })

		this.listenTo(this.boxOptions, 'select', selection => {
			let type = selection.value
			let path = reportPathsByType[type]
			this.model.set('type', type)

			//temporary remove choose init report step
			if (type == 'initiatives') {
				this.model.path(null, new InitiativeReportModel())
				return
			}

			//if no model is defined on the path, continue using the same wizard model
			if (_.isNil(path.model)) {
				this.model.path(path, this.model)
			} else {
				this.model.path(path)
			}
		})
	},

	render: function() {
		this.$el.html(this.boxOptions.el)
		this.boxOptions.render()
		this.secure()
		return this
	},

	secure : function() {
		if (!permissions.reports(globals.orgId)) {
			this.$el.prev('.banner')
				.removeClass('is-not-displayed')
				.html(i18n.get('report.warn.noPermissionSaveNewReports'))
		}
		// #37240 hide option if not enabled by license
		let features = ['scorecards', 'initiatives', 'datasets']
		_.each(features, feature => {
			if (!license[feature]) {
				this.$(`li[data-value=${feature}]`).addClass('is-not-displayed')
			}
		})
	},

	remove: function () {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.boxOptions], 'remove')
	}
})

export default Form

Form.__filename__ = 'reports/wizard/choose-report/choose-report-form.js'
